/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_P_Li2Inputs */

const tr_mesafeli_s8_p_li2 = /** @type {(inputs: Mesafeli_S8_P_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri İçeriği ve API anahtarlarını AES-256-GCM şifrelemesi ile şifreli olarak saklamak.`)
};

const en_mesafeli_s8_p_li2 = /** @type {(inputs: Mesafeli_S8_P_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To store Customer Content and API keys encrypted with AES-256-GCM encryption.`)
};

const de_mesafeli_s8_p_li2 = /** @type {(inputs: Mesafeli_S8_P_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundeninhalte und API-Schlüssel mit AES-256-GCM-Verschlüsselung verschlüsselt speichern.`)
};

const ru_mesafeli_s8_p_li2 = /** @type {(inputs: Mesafeli_S8_P_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранить Контент Клиента и API-ключи в зашифрованном виде с использованием AES-256-GCM.`)
};

/**
* | output |
* | --- |
* | "To store Customer Content and API keys encrypted with AES-256-GCM encryption." |
*
* @param {Mesafeli_S8_P_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_p_li2 = /** @type {((inputs?: Mesafeli_S8_P_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_P_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_p_li2(inputs)
	if (locale === "de") return de_mesafeli_s8_p_li2(inputs)
	if (locale === "ru") return ru_mesafeli_s8_p_li2(inputs)
	return tr_mesafeli_s8_p_li2(inputs)
});